'use client'

import { motion } from 'framer-motion'
import Image from 'next/image'

const phoneScreens = [
  {
    src: '/images/content/whim-map-tickets.png',
    alt: 'Whim app — real-time MaaS map with active tickets in Helsinki',
    label: 'Whim — MaaS Pioneer',
    caption: "World's first MaaS super-app",
  },
  {
    src: '/images/content/micromobility.jpg',
    alt: 'Integrated Micromobility',
    label: 'Micromobility',
    caption: 'Scan. Unlock. Ride.',
  },
  {
    src: '/images/content/transit-ticket.jpg',
    alt: 'Digital Ticketing',
    label: 'Digital Ticketing, EMV',
    caption: 'Tap. Scan. Board.',
  },
  {
    src: '/images/content/ev-charging-v4.png',
    alt: 'EV charging station map with high-power DC chargers',
    label: 'EV Charging',
    caption: 'AC or DC. Find and book in-app.',
  },
  {
    src: '/images/content/sovereign-routing-options-list.png',
    alt: 'Multi-modal route options with real-time pricing',
    label: 'Multi-modal Routing',
    caption: 'Multi-modal, dynamically priced.',
  },
  {
    src: '/images/content/sovereign-routing.png',
    alt: 'Multi-lingual offering',
    label: 'Multi-lingual offering',
    caption: 'National scale. Any language.',
  },
  {
    src: '/images/content/vtol-v2.png',
    alt: 'Air taxi booking with AI-planned routes',
    label: 'Air Mobility',
    caption: 'eVTOL integrated. AI Planner. Book and fly.',
  },
  {
    src: '/images/content/parking-v2.png',
    alt: 'Smart parking reservation with spot and pricing',
    label: 'Smart Parking',
    caption: 'Reserve. Navigate. Enter.',
  },
]

export function AppShowcase() {
  return (
    <section id="proof" className="py-24 bg-[#07090f] overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-xs font-mono tracking-widest text-[#00c8ff] uppercase mb-4">
            Track Record
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#e2e8f0] tracking-tight">
            Shipped at global scale.
          </h2>
          <p className="mt-4 text-[#94a3b8] max-w-2xl mx-auto text-lg">
            Whim launched as the world&apos;s first MaaS super-app. With this
            know-how, we have created a negt-gen, AI-first mobility platform for
            cities and governments.{' '}
            <span className="text-[#e2e8f0]">
              Some examples of the base experience.
            </span>
          </p>
        </div>

        {/* Phone screenshots */}
        <div className="mb-6">
          <p className="text-xs font-mono text-[#94a3b8] tracking-widest uppercase mb-8">
            In the field
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {phoneScreens.map((screen, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -8 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="group flex flex-col cursor-default"
              >
                <div
                  className="relative rounded-2xl overflow-hidden border border-[#1c2333] bg-[#0d1117] aspect-[9/19]
                    shadow-[0_24px_48px_rgba(0,0,0,0.5)]
                    group-hover:shadow-[0_24px_48px_rgba(0,200,255,0.1)]
                    group-hover:border-[#00c8ff]/40
                    transition-all duration-300"
                >
                  <Image
                    src={screen.src}
                    alt={screen.alt}
                    fill
                    className="object-cover object-top"
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                  />
                </div>
                <div className="mt-4 text-center">
                  <p className="text-sm font-mono text-[#00c8ff] min-h-[2.5rem] flex items-start justify-center">
                    {screen.label}
                  </p>
                  <p className="text-sm text-[#94a3b8] mt-1">
                    {screen.caption}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
